import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SessionService } from '../services/session.service';
import { AuthService } from '../services/auth/auth.service';
import { Role } from '../constants/roles';

/**
 * Role-based route guard (defense-in-depth; the API is the authority).
 *
 * Usage: { path, canActivate: [authGuard, roleGuard], data: { roles: ['providerAdmin'] } }
 * The BackOffice has a single audience, so a disallowed role is sent back
 * to the login instead of an internal landing.
 */
export const roleGuard: CanActivateFn = (route) => {
  const sessionService = inject(SessionService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const allowed = (route.data?.['roles'] as readonly Role[] | undefined) ?? [];
  const role = sessionService.role;

  // No role restriction declared → allow (authGuard already ran).
  if (allowed.length === 0) {
    return true;
  }

  if (role && allowed.includes(role)) {
    return true;
  }

  // Rol sin acceso al BackOffice: cerrar sesión y volver al login.
  authService.logout();
  router.navigate(['/login']);
  return false;
};
